var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34315 0.292893L15.7071 6.65685C16.0976 7.04738 16.0976 7.68054 15.7071 8.07107L9.34315 14.435C8.95262 14.8256 8.31946 14.8256 7.92893 14.435C7.53841 14.0445 7.53841 13.4113 7.92893 13.0208L12.5858 8.36396H1C0.447715 8.36396 0 7.91625 0 7.36396C0 6.81168 0.447715 6.36396 1 6.36396H12.5858L7.92893 1.70711C7.53841 1.31658 7.53841 0.683418 7.92893 0.292893C8.31946 -0.0976311 8.95262 -0.0976311 9.34315 0.292893Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSubmit);
export default __webpack_public_path__ + "static/media/search-submit.e2b36246.svg";
export { ForwardRef as ReactComponent };